import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import Stack from '../../../../../v2BaseComponents/Stack';
import Text from '../../../../../v2BaseComponents/Text';
import ListItem from '../../../../../v2BaseComponents/ListItem';

const intl = getIntl('Profiles-GuidanceContent', {
    header: 'Medical Profiles is one place to collect, organize, and share health information.',
    bullet1Pretext: 'Health',
    bullet1: ': Organize contacts, medications, conditions, visits, and allergies in this section.',
    bullet2Pretext: 'Connect',
    bullet2: ': Directly access patient portals to pull in health information securely.',
    bullet3Pretext: 'Manage',
    bullet3: ': Invite a trusted Collaborator to share access or help keep medical information accurate.',
    bullet4Pretext: 'Notes',
    bullet4:
        ": This is where you can upload files, take pictures, add information, and view Comments from those with whom you've shared access!",
});

const GuidanceContent: React.FC = () => {
    return (
        <Stack vertical fullWidth>
            <Text variant="body-1">{intl('header')}</Text>
            {[
                {
                    pretext: intl('bullet1Pretext'),
                    text: intl('bullet1'),
                },
                {
                    pretext: intl('bullet2Pretext'),
                    text: intl('bullet2'),
                },
                {
                    pretext: intl('bullet3Pretext'),
                    text: intl('bullet3'),
                },
                {
                    pretext: intl('bullet4Pretext'),
                    text: intl('bullet4'),
                },
            ].map(({ pretext, text }, index) => (
                <ListItem unordered key={index} index={index} variant="body-1">
                    <Text variant="bold-body-1">{pretext}</Text>
                    <Text variant="body-1">{text}</Text>
                </ListItem>
            ))}
        </Stack>
    );
};

export default React.memo(GuidanceContent);
